import { ComponentProps } from 'react';

import Button from 'core/ui/Button';
import KeyBind from 'core/ui/KeyBind';

type TButtonProps = Omit<
  ComponentProps<typeof Button>,
  'children' | 'link' | 'onClick'
> & { onClick?: () => void };

export const SaveButton: React.FC<TButtonProps> = props => (
  <Button {...props} type="submit" children="Save" onClick={() => undefined} />
);

export const CancelButton: React.FC<TButtonProps> = props => (
  <Button {...props} onClick={orDie(props.onClick)}>
    <KeyBind kkb="Escape" checkInControls onKeyUp={orDie(props.onClick)} />
    Cancel
  </Button>
);
